import type {FC} from 'react';
import {styled} from 'styled-components';

import {getNzbCheckHealth} from '@repo/shared/lib/nzb_check_stats';

import {UnthemedNavLink} from '@repo/shared-web/components/core/button';

import {formatDate} from '@repo/website-frontend/lib/date';
import {useNzbsu} from '@repo/website-frontend/stores/nzbsu_store';

interface NzbCheckProps {
  guid: string;
}

export const NzbCheck: FC<NzbCheckProps> = props => {
  const {guid} = props;
  const item = useNzbsu(guid);

  const check = item?.lastCheck;
  const passed = getNzbCheckHealth(check) === 'healthy' && check?.checked === 10;
  const checkColor = !check ? '#8b9099' : passed ? '#4caf50' : '#ef5350';
  const checkTitle = check
    ? `${check.outcome === 'failed' ? 'Check failed' : `${check.success}/10 samples passed`}; ${formatDate(new Date(check.ts))}`
    : 'Never checked';

  return (
    <Wrapper
      to={`/debug/nzb-health?guid=${encodeURIComponent(guid)}`}
      title={`${checkTitle}. View check details`}
      aria-label={`${checkTitle}. View check details`}
    >
      <CheckCircle $color={checkColor} aria-hidden="true" />
    </Wrapper>
  );
};
NzbCheck.displayName = 'NzbCheck';

const Wrapper = styled(UnthemedNavLink)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 24px;
  border-radius: 50%;
  &:hover {
    background-color: #ffffff15;
  }
`;

const CheckCircle = styled.div<{$color: string}>`
  background-color: ${p => p.$color};
  width: 12px;
  height: 12px;
  border-radius: 50%;
`;
